import { Vue, Component, Prop } from 'vue-property-decorator'
import { Item } from 'src/graphql/types'

@Component
export default class ItemMixinForm extends Vue {

  @Prop()
  readonly item!: Item

  @Prop()
  readonly slides!: Json[]

  @Prop()
  readonly slide!: Json

  @Prop()
  readonly correct!: string[]

  setOption (option: string, value: any, defaultValue: any = '') {
    const slide = this.slide.meta?.masterSlide || this.slide
    const currentValue = slide[option]
    // console.log(currentValue)
    // console.log(value)
    // console.log(defaultValue)
    if (value === defaultValue) {
      value = undefined
    }
    if (value !== currentValue) {
      const slidesSettings: Json = {}
      slidesSettings[`${slide.id}:${option}`] = value || null
      this.item.data?.save({ slidesSettings })
    }
  }

  setCorrect (value: string[] | null) {
    const slide = this.slide.meta?.masterSlide || this.slide
    const slidesCorrects: Json = {}
    slidesCorrects[`${slide.id}`] = value
    this.item.data?.save({ slidesCorrects })
  }
}
